export default "__VITE_ASSET__KlrqO_Zu__"